import Push from 'push.js';

const checkPermissionsGranted = () => {
    return Push.Permission.has();
};

const requestPermissions = () => {
    Push.Permission.request(() => {}, () => {});
};

const handlePermissions = () => {
    if (!checkPermissionsGranted()) {
        requestPermissions();
    }
}

export {
    checkPermissionsGranted,
    requestPermissions,
    handlePermissions
}